import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-sign-in",
    templateUrl: "./sign-in.component.html",
    styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit {
    loginData = new FormGroup({
        userName: new FormControl(null, Validators.required),
        password: new FormControl(null, Validators.required),
    });

    responseData: any;
    isLoading: boolean = false;
    isError: boolean = false;
    isServerError: boolean = false;
    constructor(private router: Router, private authService: AuthService) {}

    saveToken(
        session: any,
        name: any,
        vendor: any,
        nonPo_flag: any,
        logistics_flag: any
    ) {
        localStorage.setItem("userSession", session);
        localStorage.setItem("displayName", name);
        localStorage.setItem("vendorCode", vendor);
        localStorage.setItem("logisticFlag", logistics_flag);
        localStorage.setItem("nonPoFlag", nonPo_flag);
    }

    onLogin() {
        this.isLoading = true;
        const req = {
            userName: this.loginData.value.userName.replaceAll(/\s/g, ""),
            password: this.loginData.value.password,
        };
        this.authService.signIn(req).subscribe(
            (res) => {
                this.responseData = res;
                this.isLoading = false;

                if (this.responseData.status == "success") {
                    const vendorCode =
                        this.responseData.response.user.sellerCode;
                    const userSession =
                        this.responseData.response.session.sessionId;
                    const displayName =
                        this.responseData.response.user.displayName;
                    const nonPoFlag =
                        this.responseData.response.user.non_po_flag;
                    const logisticFlag =
                        this.responseData.response.user.logistics_flag;
                    this.saveToken(
                        userSession,
                        displayName,
                        vendorCode,
                        nonPoFlag,
                        logisticFlag
                    );

                    if (this.responseData.response.user.hasOnboarded == false) {
                        this.router.navigateByUrl("/vendor-master-data");
                    } else {
                        //this.router.navigateByUrl("/dashboard");
                        this.router.navigateByUrl("/purchase-orders");
                    }
                } else {
                    if (
                        this.responseData.message ===
                            "Invalid credentials or user not active" ||
                        this.responseData.message ===
                            "Invalid username or password"
                    ) {
                        this.isError = true;
                    } else {
                        this.isServerError = true;
                    }
                }
            },
            (error) => {
                this.isServerError = true;
                this.isLoading = false;
            }
        );
    }

    ngOnInit(): void {}
}
